import axios from "axios"
import { getStoryblokRuntimeAccessToken } from "../config/storyblok-access-token"

export default function getStorybookClient() {
  return axios.create({
    baseURL: "https://api-us.storyblok.com/v2/cdn/",
    timeout: 1000,
    params: { token: getStoryblokRuntimeAccessToken() },
  })
}

export function toSentenceCase(str: string): string | void {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }
}
